export const globalCss = `  
/*
YUI 3.18.1 (build f7e7bcb)
Copyright 2014 Yahoo! Inc. All rights reserved.
Licensed under the BSD License.
http://yuilibrary.com/license/
*/

/*
  TODO will need to remove settings on HTML since we can't namespace it.
  TODO with the prefix, should I group by selector or property for weight savings?
*/

/* Adding box-sizing model reset to border-box*/
/* Enforce a minimum width to pages that we will support no lower than */

html {
  box-sizing: border-box;
  min-width: 320px;
  color: #000;
  background: #fff;
}

html,
body {
  font-size: 16px;
}

/*
TODO remove settings on BODY since we can't namespace it.
*/
/*
  TODO test putting a class on HEAD.
      - Fails on FF.
*/
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
textarea,
p,
figure,
blockquote,
th,
td,
figure {
  margin: 0;
  padding: 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
fieldset,
img {
  border: 0;
}
/*
  TODO think about hanlding inheritence differently, maybe letting IE6 fail a bit...
*/
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: normal;
}

ol,
ul {
  list-style: none;
}

caption,
th {
  text-align: left;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}
q:before,
q:after {
  content: '';
}
abbr,
acronym {
  border: 0;
  font-variant: normal;
}
/* to preserve line-height and selector appearance */
sup {
  vertical-align: text-top;
}
sub {
  vertical-align: text-bottom;
}
input,
textarea,
select {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  *font-size: 100%; /*to enable resizing for IE*/
}
/*because legend doesn't inherit in IE */
legend {
  color: #000;
}

/* YUI CSS Detection Stamp */
#yui3-css-stamp.cssreset {
  display: none;
}

*,
* :before,
*:after {
  box-sizing: inherit;
}

/* Reset button styles. Borrowed from: https://gist.github.com/MoOx/9137295 */
button {
border: none;
margin: 0;
padding: 0;
width: auto;
overflow: visible;

background: transparent;

/* inherit font & color from ancestor */
color: inherit;
font: inherit;

/* Normalize 'line-height'. Cannot be changed from 'normal' in Firefox 4+. */
line-height: normal;

/* Corrects font smoothing for webkit */
-webkit-font-smoothing: inherit;
-moz-osx-font-smoothing: inherit;

/* Corrects inability to style clickable 'input' types in iOS */
  -webkit-appearance: none;
}







/* Bold */
@font-face {
font-family: 'AvenirNextLTPro-Demi';
font-style: normal;
src: url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-demi.woff2') format('woff2'),
  url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-demi.woff') format('woff');
}
/* Bold Italic */
@font-face {
font-family: 'AvenirNextLTPro-Demi';
font-style: italic;
src: url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-demi-it.woff2') format('woff2'),
  url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-demi-it.woff') format('woff');
}

/* Medium */
@font-face {
font-family: 'AvenirNextLTPro-Medium';
font-style: normal;
src: url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-medium.woff2') format('woff2'),
  url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-medium.woff') format('woff');
}
/* Medium Italic */
@font-face {
font-family: 'AvenirNextLTPro-Medium';
font-style: italic;
src: url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-medium-it.woff2') format('woff2'),
  url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-medium-it.woff') format('woff');
}

/* Regular */
@font-face {
font-family: 'AvenirNextLTPro-Regular';
font-style: normal;
src: url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-regular.woff2') format('woff2'),
  url('/fonts/avenir-next-lt-pro/avenir-next-lt-pro-regular.woff') format('woff');
}
/* No italic available */

html, body {
  min-width:320px;
}
`;
